import React from 'react';
import { useIntl } from 'react-intl';
import { PiBoundingBox, PiRuler } from 'react-icons/pi';
import {
  TOOLBAR_DENSITY_REGULAR,
  TOOLBAR_ORIENTATION_VERTICAL,
  TOOLBAR_TONE_SURFACE,
  TOOLBAR_VARIANT_FLOATING,
  TOOLTIP_PLACEMENT_RIGHT,
  Toolbar,
} from '@aibuild/ui';
import ChromeButton from './ChromeButton';
import { messages } from './messages';
import { RailSlot } from './ToolRail.styled';

export interface ToolRailProps {
  measuring: boolean;
  onToggleMeasure: () => void;
  /** Why Measure is unavailable, when it is. */
  measureUnavailable?: string;
  dimensions: boolean;
  onToggleDimensions: () => void;
}

const ToolRail: React.FC<ToolRailProps> = ({
  measuring,
  onToggleMeasure,
  measureUnavailable,
  dimensions,
  onToggleDimensions,
}) => {
  const intl = useIntl();
  return (
    <RailSlot>
      <Toolbar
        variant={TOOLBAR_VARIANT_FLOATING}
        tone={TOOLBAR_TONE_SURFACE}
        orientation={TOOLBAR_ORIENTATION_VERTICAL}
        density={TOOLBAR_DENSITY_REGULAR}
        ariaLabel={intl.formatMessage(messages.tools)}
        dataTestId="model-viewer__tools"
      >
        <ChromeButton
          label={intl.formatMessage(messages.measure)}
          icon={<PiRuler />}
          pressed={measuring}
          disabledReason={measureUnavailable}
          tooltipPlacement={TOOLTIP_PLACEMENT_RIGHT}
          onClick={onToggleMeasure}
          testId="model-viewer__measure"
        />
        <ChromeButton
          label={intl.formatMessage(messages.dimensions)}
          icon={<PiBoundingBox />}
          pressed={dimensions}
          tooltipPlacement={TOOLTIP_PLACEMENT_RIGHT}
          onClick={onToggleDimensions}
          testId="model-viewer__dimensions"
        />
      </Toolbar>
    </RailSlot>
  );
};

export default ToolRail;
